export default "__VITE_ASSET__DXFhGEmS__"